import { Burger, Mobile } from '../core'

export default {

  init() {

    $.mlmi = {
      mobile: new Mobile(),
    }

    /* Burger */
    let obj = this
    obj.burger = new Burger('.header__burger .burger', {
      onToggle: function() {
        $('.top-bar').css('--max-height', Math.floor($('.top-bar .container').outerHeight()) + 'px')
        if (obj.burger.isExpanded) {
          $('body').addClass('--menu-open')
        } else {
          $('body').removeClass('--menu-open')
          $('body').removeClass('--products-open')
          $('body').removeClass('--products-category-open')
          $('.products-menu .products-menu__item').removeClass('--selected')
        }
      },
    })

    /* Products */
    $('.js-toggle-products').click(function() {
      event.preventDefault()
      if ($.mlmi.mobile.isMobile) {
        $('body').toggleClass('--products-open')
        $('.js-products-menu').addClass('--ready')
      }
    })

    $('.main-menu__item--js-toggle-products, .js-products-menu').mouseenter(function() {
      if (!$.mlmi.mobile.isMobile) {
        if (!$('body').hasClass('--products-open')) {
          $('body').addClass('--products-open')
          $('.js-products-menu').addClass('--ready')
        }
      }
    })

    $('.main-menu__item--js-toggle-products, .js-products-menu').mouseleave(function() {
      if (!$.mlmi.mobile.isMobile) {
        if ($('body').hasClass('--products-open')) {
          $('body').removeClass('--products-open')
        }
      }
    })

    $('.products-menu > li > a').click(function() {
      if ($.mlmi.mobile.isMobile) {
        event.preventDefault()
        $(this).closest('.products-menu__item').addClass('--selected')
        $('body').addClass('--products-category-open')
      }
    })

    $('.js-products-menu-back').click(function() {
      event.preventDefault()
      if ($('.products-menu .products-menu__item.--selected').length > 0) {
        $('.products-menu .products-menu__item').removeClass('--selected')
        $('body').removeClass('--products-category-open')
      } else {
        $('body').removeClass('--products-open')
        $('.products-menu .products-menu__item').removeClass('--selected')
      }
    })

    /* Top bar + header */
    let calculateTopBarHeight = function() {
      let topBarHeight = $('.top-bar .container').length ? Math.floor($('.top-bar .container').outerHeight()) : 0,
      headerHeight = ($('body').hasClass('--no-top-bar') ? 0 : topBarHeight) + $('.header').outerHeight(true)
      $('body').css({
        '--top-bar-height': topBarHeight + 'px',
        '--header-height': headerHeight + 'px',
      })
    }
    $('.js-close-top-bar').click(function() {
      $('.top-bar').css('--max-height', Math.floor($('.top-bar').outerHeight()) + 'px')
      $('body').addClass('--no-top-bar')
      calculateTopBarHeight()
    })
    $(window).on('resize orientationchange load', calculateTopBarHeight)
    calculateTopBarHeight()
  }
}
